import React from 'react'
import { Button, message } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import IntlMessages from '../../util/IntlMessages'
import {
  customParse,
  formatDigits,
  isEmptyObject
} from '../../appRedux/actions/GlobalMethods'
import {
  loadIsSalePanelActive,
  loadIsPaymentPanelActionCompleteActive,
  loadIsPaymentPanelLoading,
  loadSaleOrderJson,
  loadSingleScreenPay
} from '../../appRedux/actions/MainSale'
import { loadPostMainSaleProductServices } from '../../appRedux/actions/SellScreenServices'
import {
  getDecryptID,
  getSalesOrderID,
  loadCurrentSalesOrderData,
  loadSalePaymentData,
  loadSellSelectedAttributes,
  storeCreatePayload
} from '../../appRedux/actions'
import {
  GetIndexDBDataByTableName,
  saveEntitiesDatatoIndexBD
} from '../../appRedux/actions/IndexDBActions'
import {
  CURRENT_VERSION,
  INDEX_DB_NAME,
  INDEX_DB_TABLES
} from '../../constants/IndexDBData'

const CartActionBar = props => {
  const { allowMakeSales } = props
  const dispatch = useDispatch()
  const getCurrData = props.getCurrData
    ? props.getCurrData
    : {
        currencyCode: '',
        currencyName: '',
        currencySymbol: ''
      }

  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  const getIsRefundSale = useSelector(
    ({ MainSale }) => MainSale.getIsRefundSale
  )
  const getSaleOrderJson = useSelector(
    ({ MainSale }) => MainSale.getSaleOrderJson
  )
  const getSalesOrderStatuses = useSelector(
    ({ MainSale }) => MainSale.getSalesOrderStatuses
  )
  const getCurrentSalesOrderData = useSelector(
    ({ Sell }) => Sell.currentSalesOrderData
  )
  const getReduxSaleProductJsonData = useSelector(
    ({ Sell }) => Sell.saleProductJsonData
  )
  const getIsExchangeSale = useSelector(
    ({ MainSale }) => MainSale.getIsExchangeSale
  )
  const getSelectedOutlet = useSelector(
    ({ commonConfigs }) => commonConfigs.getSelectedOutlet
  )
  const getDeletedProds = useSelector(({ MainSale }) => MainSale.deletedProds)
  const getReduxSalePaymentData = useSelector(
    ({ Sell }) => Sell.salePaymentData
  )
  const getSelectedReg = useSelector(
    ({ commonConfigs }) => commonConfigs.getSelectedReggg
  )
  const getIsSalePaymentProcessStart = useSelector(
    ({ MainSale }) => MainSale.getIsSalePaymentProcessStart
  )
  const getSalePayments = useSelector(
    ({ MainSale }) => MainSale.getSalePayments
  )
  const formAmountToPay = useSelector(({ MainSale }) => MainSale.amountToPay)
  const sellSelAttributes = useSelector(({ Sell }) => Sell.sellSelAttributes)
  const showInventoryPopup = useSelector(({ Sell }) => Sell.showInventoryPopup)
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)
  const singleScreenForCart = useSelector(
    ({ MainSale }) => MainSale.singleScreenForCart
  )

  const [showChange, setShowChange] = React.useState(false)

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      if (
        getIsSalePaymentProcessStart &&
        getSaleOrderJson &&
        getSaleOrderJson.Change
      ) {
        setShowChange(true)
      }
    }
    return () => {
      mounted = false
    }
  }, [getIsSalePaymentProcessStart])

  const handleSalePanelActive = isPaymentPanelActive => {
    if (singleScreenForCart)
      dispatch(loadSingleScreenPay(!isPaymentPanelActive))
    else dispatch(loadIsSalePanelActive(isPaymentPanelActive))

    dispatch(loadIsPaymentPanelActionCompleteActive(false))
    if (!isPaymentPanelActive) {
      dispatch(loadIsPaymentPanelLoading(true))
      let body = getSaleOrderJson
      body.E_RegisterID = getSelectedReg
      body.E_OutletID = getSelectedOutlet
      const cashRegPay = localStorage.getItem('cashManageID')
      if (cashRegPay && cashRegPay != '') {
        body.CashRegPaymentID = cashRegPay
        body.DeletedProds = getDeletedProds ? getDeletedProds : []
        let isOnlineAllowed = false
        if (isOnline) {
          isOnlineAllowed = true
          if (getSalePayments && getSalePayments.length > 0) {
            if (!body.E_SalesOrderID || body.E_SalesOrderID == '') {
              isOnlineAllowed = false
            }
          }
        }
        // getSalePayments
        if (isOnlineAllowed) {
          dispatch(
            loadPostMainSaleProductServices(
              body,
              getSalesOrderStatuses,
              getCurrentSalesOrderData,
              false,
              false,
              true,
              false,
              getReduxSalePaymentData,
              sellSelAttributes,
              getReduxSaleProductJsonData
            )
          )
        } else {
          // // // NOTE: OFFLINE
          // localStorage.setItem('orderGuidID', getCurrentSalesOrderData.indexKey)
          let currOrderSale = { ...getCurrentSalesOrderData }
          let salesOrder = { ...getSaleOrderJson }
          const storeReqID = localStorage.getItem('storeReqNo')
          const receipt_code = `${getCurrentSalesOrderData.indexKey}`
          currOrderSale.receiptCode = receipt_code
          salesOrder.receiptCode = receipt_code
          dispatch(loadCurrentSalesOrderData(currOrderSale))
          dispatch(loadSaleOrderJson(salesOrder))
          storeCreatePayload(
            getCurrentSalesOrderData.indexKey,
            body,
            receipt_code
          )
          let orderGuidID = getSalesOrderID()
          let data = {}
          let payData = getReduxSalePaymentData
          if (payData && !isEmptyObject(payData)) {
            payData.orderGuidID = orderGuidID // `${getCurrentSalesOrderData.indexKey}`
            data = payData
          } else {
            data = {
              orderGuidID: orderGuidID, // `${getCurrentSalesOrderData.indexKey}`,
              amount: customParse(body.TotalPrice)
            }
          }
          dispatch(loadSalePaymentData(data))

          dispatch(loadSellSelectedAttributes(sellSelAttributes))
          dispatch(loadIsPaymentPanelLoading(false))
          //// get api response
          // // // marking to identify that the prods coming first time from backend
          //  // // NOTE: AVOIDING THE AGAIN BUILDING OF JSONs

          //  // // getReduxSaleProductJsonData
          // if (response[0].products && response[0].products.length > 0) {
          //   response[0].products.map(a => a.firstTime = true);
          // }
          // let saleOrderData = response[0];
          // saleIsInProgress(dispatch, saleOrderData);
        }
      } else {
        message.warn('Kindly recheck register is open & selected', 4)
      }
    }
  }

  return (
    <div className='cart-total-div div-flow'>
      <Button
        className={
          getIsRefundSale &&
          getSaleOrderJson &&
          getSaleOrderJson.finals &&
          getSaleOrderJson.finals.inc < 0
            ? 'dk-btn-cancel custom-btn-sell dk-color--red'
            : 'dk-btn-add '
        }
        type='primary'
        block
        onClick={e => handleSalePanelActive(false)}
        disabled={
          isEmptyObject(getSaleOrderJson) ||
          showInventoryPopup ||
          !allowMakeSales
            ? true
            : false
        }
      >
        <div className='Pay-Quantity'>
          <div className='pay-action pay-action-label'>
            {getIsRefundSale ? (
              getIsExchangeSale ? (
                <IntlMessages id='sell.sell.exchange' />
              ) : (
                <IntlMessages id='sell.sell.refund' />
              )
            ) : (
              <IntlMessages id='sell.sell.pay' />
            )}{' '}
            {''}
          </div>
          {getSaleOrderJson && (
            <span className='dk-text--sub mx-2'>
              {` ${
                getSaleOrderJson.totalItems ? getSaleOrderJson.totalItems : '0'
              } `}
              {getSaleOrderJson.totalItems &&
              getSaleOrderJson.totalItems > 1 ? (
                <IntlMessages id='sell.sell.items' />
              ) : (
                <IntlMessages id='sell.sell.item' />
              )}
            </span>
          )}
        </div>

    
        {showChange && (
          <div className='change-amount-return'>
            <span>
              {`CHANGE ${
                getCurrData.currencySymbol != null
                  ? getCurrData.currencySymbol
                  : getCurrData.currencyName != null
                  ? getCurrData.currencyName
                  : getCurrData.currencyCode
                  ? getCurrData.currencyCode
                  : ''
              } ${
                getSaleOrderJson && getSaleOrderJson.Change
                  ? formatDigits(
                      getSaleOrderJson.Change,
                      getDefaultDecimalPlaces
                    )
                  : '0.00'
              }`}
            </span>
          </div>
        )}

        <div className='pay-amount-wrapper'>
          <div className='pay-action pay-action-value'>
            {`${
              getCurrData.currencyCode != null
                ? getCurrData.currencyCode
                : getCurrData.currencyName != null
                ? getCurrData.currencyName
                : getCurrData.currencySymbol
            } `}
            {formAmountToPay
              ? formatDigits(formAmountToPay, getDefaultDecimalPlaces)
              : '0.00'}
          </div>

          {getIsSalePaymentProcessStart && (
            <div className='payment-paid'>
              <span>
                {`PAID ${
                  getCurrData.currencySymbol != null
                    ? getCurrData.currencySymbol
                    : getCurrData.currencyName != null
                    ? getCurrData.currencyName
                    : getCurrData.currencyCode
                    ? getCurrData.currencyCode
                    : ''
                } ${
                  getSalePayments && getSalePayments != undefined
                    ? formatDigits(
                        getSalePayments.reduce((a, v) => (a = a + v.amount), 0),
                        getDefaultDecimalPlaces
                      )
                    : '0.00'
                }`}
              </span>
            </div>
          )}
        </div>
      </Button>
    </div>
  )
}

export default CartActionBar
